import {
  AuthContextProps,
  FormHookDispState,
  CustomerData,
  GenerationData,
} from "../../shared/data/types";

export interface FetchProps {
  sendRequest: (
    url: string,
    method?: string,
    body?: BodyInit,
    headers?: HeadersInit,
    successMessage?: boolean
  ) => Promise<any>;
  auth: AuthContextProps;
}

// GET SINGLE CUSTOMER /////////////////////////////////////////////
////////////////////////////////////////////////////////////////////
interface GetSingleGenerationProps extends FetchProps {
  pid: string;
  setLoadedGeneration: React.Dispatch<React.SetStateAction<GenerationData>>;
  notFrontId?: boolean;
}

export const getSingleGeneration = async (props: GetSingleGenerationProps) => {
  const {
    sendRequest,
    auth,
    pid,
    setLoadedGeneration,
    notFrontId = false,
  } = props;

  try {
    let apiUrl = `${
      process.env.REACT_APP_BACKEND_URL
    }/generations/single/${pid}${notFrontId ? "/true" : ""}`;
    const responseData: { generation: GenerationData } = await sendRequest(
      apiUrl,
      "GET",
      null,
      {
        Authorization: "Bearer " + auth.token,
      }
    );

    setLoadedGeneration(responseData.generation);
  } catch (err) {}
};
